import React, { useState, useEffect} from 'react';
import { X, ArrowRightLeft } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from "../../services/axiosInstance";
import {
    fetchRackListMove
} from "../pages/dashboard/dashboardSlice";

// info kedaluwarsa disembunyikan; ubah ke true untuk memunculkan lagi
const SHOW_EXPIRY = false;

export default function RackDetailModal({ rack, rackName, data, onClose }) {

    const [showMove, setShowMove] = useState(false);
    //const [rackList, setRackList] = useState([]);
    const dispatch = useDispatch();

    const [showForm, setShowForm] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [formData, setFormData] = useState({
        id: null,
        racking_id: rack?.id || '',
        level_code: '',
        kode_palet: '',
        sku: '',
        batch_no: '',
        qty: ''
    });

    {/*const openAddForm = () => {
        setIsEdit(false);

        setFormData({
            id: null,
            racking_id: rack.id,
            level_code: rack.level_code || '',
            kode_palet: '',
            sku: '',
            batch_no: '',
            qty: ''
        });

        setShowForm(true);
    };*/}

    {/*const openEditForm = (item) => {
        setIsEdit(true);

        setFormData({
            id: item.id,
            racking_id: item.racking_id,
            level_code: item.level_code,
            kode_palet: item.kode_palet,
            sku: item.sku,
            batch_no: item.batch_no,
            qty: item.qty
        });

        setShowForm(true);
    };*/}

    const saveItem = async () => {
        try {

            if (isEdit) {
                await axios.put(
                    `/dashracking/detail/${formData.id}`,
                    formData
                );
            } else {
                await axios.post(
                    `/dashracking/detail`,
                    formData
                );
            }

            alert(
                isEdit
                    ? 'Data berhasil diubah'
                    : 'Data berhasil ditambahkan'
            );

            setShowForm(false);

            setTimeout(() => {
                window.location.reload();
            }, 500);

        } catch (err) {

            alert(
                err.response?.data?.message ||
                'Gagal menyimpan data'
            );

        }
    };

    const rackListMove = useSelector(
        state => state.dashboard.rackListMove
    );

    const [moveData, setMoveData] = useState({
        detail_id: null,
        rack_code: '',
        level_code: ''
    });

    const saveMove = async () => {

       try {

        const response = await axios.post(
            '/dashracking/move-location',
            moveData
        );

           setTimeout(() => {
               window.location.reload();
           }, 500);

        //console.log('SUCCESS', response.data);

        alert('Berhasil dipindah');

        setShowMove(false);

    } catch (err) {

        //console.log('ERROR FULL', err);

        //console.log('ERROR RESPONSE', err.response);

        //console.log('ERROR DATA', err.response?.data);

        //console.log('ERROR MESSAGE', err.message);

        alert(
            err.response?.data?.message ||
            'Gagal memindahkan lokasi'
        );

    }
    };

    useEffect(() => {
        if (showMove) {
            dispatch(fetchRackListMove());
        }
    }, [showMove, dispatch]);

    const isExpired = (date) => {
        if (!date) return false;
        const d = new Date(date);
        return !Number.isNaN(d.getTime()) && d < new Date();
    };

    const fmt = (n) =>
        n === null || n === undefined || Number.isNaN(Number(n))
            ? '-'
            : Number(n).toLocaleString('id-ID');

    const fmtDate = (date) => {
        if (!date) return '-';
        const d = new Date(date);
        if (Number.isNaN(d.getTime())) return String(date);
        return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    // Esc menutup popup paling atas
    useEffect(() => {
        const onKey = (e) => {
            if (e.key !== 'Escape') return;
            if (showForm) setShowForm(false);
            else if (showMove) setShowMove(false);
            else onClose?.();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [showForm, showMove, onClose]);

    const inputClass = 'h-10 w-full border border-line rounded-md px-3 text-sm text-body bg-white focus:border-ink focus:ring-0';
    const labelClass = 'block text-xs text-muted mb-1';

    if (!rack) return null;

    const items = Array.isArray(data) ? data : [];
    const totalQty = items.reduce((a, it) => a + Number(it.qty || 0), 0);

    return (
        <div
            className="fixed inset-0 bg-slate-900/50 flex items-center justify-center z-[55] p-4"
            onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}
        >
            <div
                role="dialog"
                aria-modal="true"
                className="bg-white w-full max-w-[640px] max-h-[88vh] rounded-xl shadow-2xl flex flex-col overflow-hidden"
            >

                {/* HEADER */}
                <div className="flex items-start justify-between gap-4 px-5 py-4 border-b border-line">
                    <div>
                        <div className="text-xs text-muted">
                            {rackName ? `Rak ${rackName}` : 'Detail slot'}
                        </div>
                        <h2 className="text-xl font-semibold text-body leading-tight mt-0.5">
                            Slot {rack.level_code}
                        </h2>
                        <div className="text-sm text-muted mt-1">
                            {fmt(items.length)} item, total qty {fmt(totalQty)}
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="Tutup"
                        className="p-2 -mr-2 rounded-md text-muted hover:text-body hover:bg-surface"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* CONTENT */}
                {!data ? (
                    <div className="px-5 py-10 text-center text-sm text-muted">Memuat isi slot…</div>
                ) : items.length === 0 ? (
                    <div className="px-5 py-10 text-center text-sm text-muted">Slot ini kosong.</div>
                ) : (
                    <ul className="flex-1 overflow-auto divide-y divide-line">
                        {items.map((item, i) => {
                            const expired = SHOW_EXPIRY && isExpired(item.due_date);
                            return (
                                <li key={item.id ?? i} className={`px-5 py-4 ${expired ? 'bg-red-50/70' : ''}`}>
                                    <div className="flex items-start justify-between gap-3">
                                        <div className="min-w-0">
                                            <div className="font-semibold text-body leading-snug">
                                                {item.name_product || '-'}
                                            </div>
                                            <div className="text-xs text-muted tabular-nums mt-0.5">{item.sku}</div>
                                        </div>
                                        <div className="text-right shrink-0">
                                            <div className="text-lg font-semibold tabular-nums leading-none">{fmt(item.qty)}</div>
                                            <div className="text-[11px] text-muted mt-1">qty</div>
                                        </div>
                                    </div>

                                    <dl className={`grid ${SHOW_EXPIRY ? "grid-cols-3" : "grid-cols-2"} gap-3 mt-3 text-sm`}>
                                        <div>
                                            <dt className="text-xs text-muted">Kode palet</dt>
                                            <dd>
                                                {item.kode_palet ? (
                                                    <span className="inline-block mt-0.5 px-1.5 py-0.5 rounded bg-ink-100 text-ink text-xs font-semibold">
                                                        {item.kode_palet}
                                                    </span>
                                                ) : (
                                                    <span className="text-muted">-</span>
                                                )}
                                            </dd>
                                        </div>
                                        <div>
                                            <dt className="text-xs text-muted">Lot number</dt>
                                            <dd className="font-medium tabular-nums truncate" title={item.batch_no}>{item.batch_no || '-'}</dd>
                                        </div>
                                        {SHOW_EXPIRY && (
                                        <div>
                                            <dt className="text-xs text-muted">Kedaluwarsa</dt>
                                            <dd className={`font-medium tabular-nums ${expired ? 'text-red-700' : ''}`}>
                                                {fmtDate(item.due_date)}
                                                {expired && (
                                                    <span className="ml-1.5 text-[10px] font-semibold rounded bg-red-100 text-red-700 px-1 py-0.5 align-middle">
                                                        lewat
                                                    </span>
                                                )}
                                            </dd>
                                        </div>
                                        )}
                                    </dl>

                                    <div className="mt-3 flex justify-end">
                                        <button
                                            type="button"
                                            className="inline-flex items-center gap-1.5 h-8 px-3 text-sm font-medium text-ink border border-line rounded-md hover:border-ink hover:bg-ink-100"
                                            onClick={() => {
                                                setMoveData({
                                                    detail_id: item.id,
                                                    rack_code: '',
                                                    level_code: item.level_code || ''
                                                });

                                                setShowMove(true);
                                            }}
                                        >
                                            <ArrowRightLeft size={15} />
                                            Pindahkan
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )}

                {
                    showMove && (
                        <div
                            className="fixed inset-0 bg-slate-900/50 flex items-center justify-center z-[60] p-4"
                            onMouseDown={(e) => e.target === e.currentTarget && setShowMove(false)}
                        >
                            <div role="dialog" aria-modal="true" className="bg-white rounded-xl w-full max-w-[420px] shadow-2xl">

                                <div className="px-5 py-4 border-b border-line">
                                    <h3 className="text-lg font-semibold text-body">Pindahkan lokasi</h3>
                                    <p className="text-sm text-muted mt-0.5">
                                        Dari slot {rack.level_code}{rackName ? ` di rak ${rackName}` : ''}
                                    </p>
                                </div>

                                <div className="px-5 py-4 space-y-4">
                                    <label className="block">
                                        <span className={labelClass}>Rak tujuan</span>
                                        <select
                                            className={inputClass}
                                            value={moveData.rack_code}
                                            onChange={(e) =>
                                                setMoveData({
                                                    ...moveData,
                                                    rack_code: e.target.value
                                                })
                                            }
                                        >
                                            <option value="">Pilih rak</option>

                                            {rackListMove.map((rack) => (
                                                <option
                                                    key={rack.id}
                                                    value={rack.code}
                                                >
                                                    [{rack.warehouse_name}] {rack.code} - {rack.racks_name}
                                                </option>
                                            ))}
                                        </select>
                                    </label>

                                    <label className="block">
                                        <span className={labelClass}>Slot tujuan (baris.kolom, mis. 2.3)</span>
                                        <input
                                            type="text"
                                            className={inputClass}
                                            value={moveData.level_code}
                                            onChange={(e) =>
                                                setMoveData({
                                                    ...moveData,
                                                    level_code: e.target.value
                                                })
                                            }
                                        />
                                    </label>
                                </div>

                                <div className="flex justify-end gap-2 px-5 py-4 border-t border-line">
                                    <button
                                        type="button"
                                        className="h-9 px-4 text-sm border border-line rounded-md hover:bg-surface"
                                        onClick={() => setShowMove(false)}
                                    >
                                        Batal
                                    </button>

                                    <button
                                        type="button"
                                        disabled={!moveData.rack_code || !moveData.level_code}
                                        className="h-9 px-4 text-sm font-semibold bg-ink text-white rounded-md hover:bg-ink-700 disabled:opacity-40"
                                        onClick={saveMove}
                                    >
                                        Pindahkan
                                    </button>
                                </div>

                            </div>
                        </div>
                    )
                }

                {
                    showForm && (
                        <div className="fixed inset-0 bg-slate-900/50 flex items-center justify-center z-[70] p-4">

                            <div className="bg-white rounded-xl w-full max-w-[500px] shadow-2xl">

                                <h3 className="text-lg font-semibold px-5 py-4 border-b border-line">
                                    {isEdit ? 'Ubah item' : 'Tambah item'}
                                </h3>

                                <div className="space-y-3 px-5 py-4">
                                    {[
                                        ['racking_id', 'Racking ID', 'text'],
                                        ['level_code', 'Slot (baris.kolom)', 'text'],
                                        ['kode_palet', 'Kode palet', 'text'],
                                        ['sku', 'SKU', 'text'],
                                        ['batch_no', 'Lot number', 'text'],
                                        ['qty', 'Qty', 'number']
                                    ].map(([key, label, type]) => (
                                        <label key={key} className="block">
                                            <span className={labelClass}>{label}</span>
                                            <input
                                                type={type}
                                                className={inputClass}
                                                value={formData[key]}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        [key]: e.target.value
                                                    })
                                                }
                                            />
                                        </label>
                                    ))}
                                </div>

                                <div className="flex justify-end gap-2 px-5 py-4 border-t border-line">
                                    <button
                                        type="button"
                                        className="h-9 px-4 text-sm border border-line rounded-md hover:bg-surface"
                                        onClick={() => setShowForm(false)}
                                    >
                                        Batal
                                    </button>

                                    <button
                                        type="button"
                                        className="h-9 px-4 text-sm font-semibold bg-ink text-white rounded-md hover:bg-ink-700"
                                        onClick={saveItem}
                                    >
                                        {isEdit ? 'Simpan perubahan' : 'Tambah item'}
                                    </button>
                                </div>

                            </div>

                        </div>
                    )
                }
            </div>
        </div>
    );
}
